// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'pels-d2b32',
    appId: '1:993362048761:web:ca1870681328618484d428',
    storageBucket: 'pels-d2b32.appspot.com',
    apiKey: 'AIzaSyB0ZmgXHWPkhocN7pO7gyVZZlueA2G68Yk',
    authDomain: 'pels-d2b32.firebaseapp.com',
    messagingSenderId: '993362048761',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
